import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-account-tab2',
  templateUrl: './my-account-tab2.component.html',
  styleUrls: ['./my-account-tab2.component.scss']
})
export class MyAccountTab2Component implements OnInit {
  MATitle = 'Payments'

  MAPaymentsForm = [
    {
      for: 'MASortCode',
      text: 'Sort Code',
      type: 'text',
      className: 'form-control',
      id: 'MASortCode',
      placeHolder: '12-34-56'
    },
    {
      for: 'MAAccountNumber',
      text: 'Account Number',
      type: 'text',
      className: 'form-control',
      id: 'MAAccountNumber',
      placeHolder: '1234 56 78'
    },
    {
      for: 'MAPostCode2',
      text: 'Post Code',
      type: 'text',
      className: 'form-control',
      id: 'MAPostCode2',
      placeHolder: 'Ab12CD'
    },
    {
      for: 'MAPUpdate',
      text: 'Update',
      type: 'submit',
      className: 'btn next-btn form-control',
      id: 'MAPUpdate',
      value: 'Update',
    }
  ]

  constructor() { }

  ngOnInit() {
  }

}
